<template>
  <section id="toxicology-add-test-block">
    <el-tabs v-model="activeToxicologyTab">
      <el-tab-pane name="screening">
        <template #label>
          <el-checkbox class="position-relative-top-3" :model-value="isMultiCheckAll('TOXICOLOGY', ['SCREENING', 'SCREENING_VALIDITY'])
            " @change="
              toggleCheckbox(
                'screening',
                ['SCREENING', 'SCREENING_VALIDITY'],
                true,
                $event
              )
              "></el-checkbox>
          <span class="ml-10">Screening</span>
        </template>

        <ul class="add-tests-selection">

          <li class="each-test" v-for="(category, index) of getCaseCategoryBasedData(
            'TOXICOLOGY',
            ['SCREENING', 'SCREENING_VALIDITY'],
            'screening'
          )" :key="index">
            <el-collapse v-model="activeNameCollapseScreening" accordion>
              <el-collapse-item :name="index">
                <template #title>{{ category.panel_title }}</template>
                <el-checkbox class="test-category" :model-value="isCheckAll(category.case_type_code, category.panel_id)
                  " @change="
                    checkAll(
                      $event,
                      category.case_type_code,
                      category.panel_id
                    )
                    ">All
                </el-checkbox>
                <el-checkbox-group v-model="selectedCategoriesWithTests">
                  <div v-for="(item, index) of getCategoryWiseTestsData(
                    category.case_type_code,
                    category.panel_code
                  )" :key="index">
                    <div class="each-check-box">
                      <el-checkbox :label="item.label_value" :value="item">{{
                        item.test_name
                        }}</el-checkbox>
                    </div>
                  </div>
                </el-checkbox-group>
              </el-collapse-item>
            </el-collapse>
          </li>
        </ul>
      </el-tab-pane>
      <el-tab-pane name="confirmation">
        <template #label>
          <el-checkbox class="position-relative-top-3" :model-value="isMultiCheckAll(
            'TOXICOLOGY',
            ['SCREENING', 'ETG_ETS', 'SCREENING_VALIDITY', 'D_L_Isomer','ORAL_FLUID_TOX_CONFIRMATION','ORAL_FLUID_TOX_CONFIRMATION_SCREENING','ORAL_FLUID_TOX_SCREENING','ETG/ETS'],
            false
          )
            " @change="
              toggleCheckbox(
                'confirmation',
                ['SCREENING', 'ETG_ETS', 'SCREENING_VALIDITY', 'D_L_Isomer','ORAL_FLUID_TOX_CONFIRMATION','ETG/ETS','ORAL_FLUID_TOX_CONFIRMATION_SCREENING','ORAL_FLUID_TOX_SCREENING'],
                false,
                $event
              )
              "></el-checkbox>
          <span class="ml-10">Confirmation</span>
        </template>

        <ul class="add-tests-selection">
          <li class="each-test" v-for="(category, index) of getCaseCategoryBasedData(
            'TOXICOLOGY',
            ['SCREENING', 'ETG_ETS', 'SCREENING_VALIDITY', 'D_L_Isomer','ORAL_FLUID_TOX_CONFIRMATION','ORAL_FLUID_TOX_CONFIRMATION_SCREENING','ETG/ETS','ORAL_FLUID_TOX_SCREENING'],
            'confirmation',
            false
          )" :key="index">
            <el-collapse v-model="activeNameCollapse" accordion>
              <el-collapse-item :name="index" class="screening">
                <template #title>
                  <el-checkbox class="el-collapse-checkbox" style="position: relative; top: 2px; padding: 0 10px 0 0"
                    :model-value="isCheckAll(
                      category.case_type_code,
                      category.panel_id
                    )
                      " @change="
                        checkAll(
                          $event,
                          category.case_type_code,
                          category.panel_id
                        )
                        "></el-checkbox>
                  {{ category.panel_title }}</template>
                <el-checkbox class="test-category" :model-value="isCheckAll(category.case_type_code, category.panel_id)
                  " @change="
                    checkAll(
                      $event,
                      category.case_type_code,
                      category.panel_id
                    )
                    ">All</el-checkbox>
                <el-checkbox-group v-model="selectedCategoriesWithTests">
                  <div v-for="(item, index) of getCategoryWiseTestsData(
                    category.case_type_code,
                    category.panel_code
                  )" :key="index">
                    <div class="each-check-box">
                      <el-checkbox :label="item.label_value" :value="item"
                        @change="selectSingleTest($event, item.panel_id, item._id)">{{
                          item.test_name
                        }}</el-checkbox>
                    </div>
                  </div>
                </el-checkbox-group>
              </el-collapse-item>
            </el-collapse>
          </li>
        </ul>
      </el-tab-pane>
      <el-tab-pane name="ETG/ETS">
        <template #label>
          <el-checkbox class="position-relative-top-3" :model-value="isMultiCheckAll('TOXICOLOGY', ['ETG_ETS','ETG/ETS'])"
            @change="toggleCheckbox('ETG_ETS', ['ETG_ETS','ETG/ETS'], true, $event)"></el-checkbox>
          <span class="ml-10">ETG/ETS</span>
        </template>

        <ul class="add-tests-selection">
          <li class="each-test" v-for="(category, index) of getCaseCategoryBasedData(
            'TOXICOLOGY',
            ['ETG_ETS','ETG/ETS'],
            'ETG_ETS'
          )" :key="index">
            <el-collapse v-model="activeNameCollapseScreening" accordion>
              <el-collapse-item :name="index">
                <template #title>{{ category.panel_title }}</template>
                <el-checkbox class="test-category" :model-value="isCheckAll(category.case_type_code, category.panel_id)
                  " @change="
                    checkAll(
                      $event,
                      category.case_type_code,
                      category.panel_id
                    )
                    ">All
                </el-checkbox>

                <el-checkbox-group v-model="selectedCategoriesWithTests">
                  <div v-for="(item, index) of getCategoryWiseTestsData(
                    category.case_type_code,
                    category.panel_code
                  )" :key="index">
                    <div class="each-check-box">
                      <el-checkbox :label="item.label_value" :value="item">{{
                        item.test_name
                        }}</el-checkbox>
                    </div>
                  </div>
                </el-checkbox-group>
              </el-collapse-item>
            </el-collapse>
          </li>
        </ul>
      </el-tab-pane>
      <el-tab-pane name="dl isomer">
        <template #label>
          <el-checkbox class="position-relative-top-3" :model-value="isMultiCheckAll('TOXICOLOGY', ['D_L_Isomer'])"
            @change="toggleCheckbox('dl isomer', ['D_L_Isomer'], true, $event)"></el-checkbox>
          <span class="ml-10">D & L Isomer</span>
        </template>
        

        <ul class="add-tests-selection">
          <li class="note-text">
            <span>Note : D & L Isomer will be tested if the methamphetamine result
              is positive
            </span>
          </li>
          <li class="each-test" v-for="(category, index) of getCaseCategoryBasedData(
            'TOXICOLOGY',
            ['D_L_Isomer'],
            'dl isomer'
          )" :key="index">
            <el-collapse v-model="activeNameCollapseScreening" accordion>
              <el-collapse-item :name="index">
                <template #title>{{ category.panel_title }}</template>
                <el-checkbox class="test-category" :model-value="isCheckAll(category.case_type_code, category.panel_id)
                  " @change="
                    checkAll(
                      $event,
                      category.case_type_code,
                      category.panel_id
                    )
                    ">All
                </el-checkbox>

                <el-checkbox-group v-model="selectedCategoriesWithTests">
                  <div v-for="(item, index) of getCategoryWiseTestsData(
                    category.case_type_code,
                    category.panel_code
                  )" :key="index">
                    <div class="each-check-box">
                      <el-checkbox :label="item.label_value" :value="item">{{
                        item.test_name
                        }}</el-checkbox>
                    </div>
                  </div>
                </el-checkbox-group>
              </el-collapse-item>
            </el-collapse>
          </li>
        </ul>
      </el-tab-pane>
      <el-tab-pane name="oral fluid">
        <template #label>
          <!-- <el-checkbox class="position-relative-top-3" :model-value="isMultiCheckAll('TOXICOLOGY', ['ORAL_FLUID_TOX_CONFIRMATION'])"
            @change="toggleCheckbox('Oral Fluid', ['ORAL_FLUID_TOX_CONFIRMATION'], true, $event)"></el-checkbox> -->
          <span class="ml-10">Oral Fluid Tox</span>
        </template>

        <ul class="add-tests-selection">
          <li class="each-test" v-for="(category, index) of getCaseCategoryBasedData(
            'TOXICOLOGY',
            ['ORAL_FLUID_TOX_CONFIRMATION', 'ORAL_FLUID_TOX_CONFIRMATION_SCREENING', 'ORAL_FLUID_TOX_SCREENING'],
            'oral fluid'
          )" :key="index">
            <el-collapse v-model="activeNameCollapseScreening" accordion>
              <el-collapse-item :name="index">
                <template #title>{{ category.panel_title }}</template>
                <el-checkbox class="test-category" :model-value="isCheckAll(category.case_type_code, category.panel_id)
                  " @change="
                    checkAll(
                      $event,
                      category.case_type_code,
                      category.panel_id
                    )
                    ">All
                </el-checkbox>

                <el-checkbox-group v-model="selectedCategoriesWithTests">
                  <div v-for="(item, index) of getCategoryWiseTestsData(
                    category.case_type_code,
                    category.panel_code
                  )" :key="index">
                    <div class="each-check-box">
                      <el-checkbox :label="item.label_value" :value="item">{{
                        item.test_name
                        }}</el-checkbox>
                    </div>
                  </div>
                </el-checkbox-group>
              </el-collapse-item>
            </el-collapse>
          </li>
        </ul>
      </el-tab-pane>
    </el-tabs>
  </section>
</template>

<script>
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";
import AppHelper from "@/mixins/AppHelper";
import { mapGetters } from "vuex";
export default {
  mixins: [UserPermissionsHelper],
  props: [
    "panelTestsData",
    "searchString",
    "selectedPanel",
  ],
  data() {
    return {
      activeToxicologyTab: "screening",
      activeNameCollapse: "",
      activeNameCollapseScreening: [0, 1],
      panelsTestsData: {
        selectedTestIds: [],
        selectedCoriellPanels: [],
        selectedCategories: [],
        selectedGroup: [],
        selectedTestsInfo: []
      },
      selectedCategories: [],
      selectedCategoriesWithTests: [],
    };
  },
  computed: {
    ...mapGetters("labTests", [
      "getNewLabGroupPanelTests",
    ]),
  },
  mounted() {
    try {
      this.panelsTestsData = this.panelTestsData;
      let alreadySelectedData = this.getAlreadySelectedData(this.panelsTestsData.selectedCategories);
      this.updateTestBasedOnEvent(true, alreadySelectedData)
    } catch (err) {
      console.log(err);
    }
  },
  methods: {
    toggleCheckbox(type, category, include = true, check = true) {
      let data = [];

      if (include) {
        data = [...this.getNewLabGroupPanelTests.filter(
          (el) =>
            el.case_type_code == "TOXICOLOGY" &&
            category.indexOf(el.panel_code) != -1
        )];
      } else {
        data = [...this.getNewLabGroupPanelTests.filter(
          (el) =>
            el.case_type_code === "TOXICOLOGY" &&
            category.indexOf(el.panel_code) == -1
        )];
      }

      this.updateTestBasedOnEvent(check, data)

    },
    getCaseCategoryBasedData(caseType, category, type, include = true) {
      let data = "";
      let outputWithFullDetails = [];
      if (this.getNewLabGroupPanelTests) {
        if (include) {
          data = this.getNewLabGroupPanelTests.filter(
            (el) =>
              el.case_type_code &&
              el.case_type_code === caseType &&
              category.indexOf(el.panel_code) != -1 &&
              (!this.searchString ||
                el.test_name
                  .toLowerCase()
                  .includes(this.searchString.toLowerCase()) ||
                el.panel_title
                  .toLowerCase()
                  .includes(this.searchString.toLowerCase()))
          );
        } else {
          data = this.getNewLabGroupPanelTests.filter(
            (el) =>
              el.case_type_code &&
              el.case_type_code === caseType &&
              category.indexOf(el.panel_code) == -1 &&
              (!this.searchString ||
                el.test_name
                  .toLowerCase()
                  .includes(this.searchString.toLowerCase()) ||
                el.panel_title
                  .toLowerCase()
                  .includes(this.searchString.toLowerCase()))
          );
        }

        let flags = [],
          output = [],
          l = data.length,
          i;

        for (i = 0; i < l; i++) {
          if (flags[data[i].panel_code]) continue;
          flags[data[i].panel_code] = true;
          output.push(data[i].panel_code);
          outputWithFullDetails.push(data[i]);
        }
      } else {
        return outputWithFullDetails;
      }
      return outputWithFullDetails;
    },
    getCategoryWiseTestsData(caseType, category) {
      let data = [];
      if (this.searchString) {
        data = this.getNewLabGroupPanelTests.filter(
          (el) =>
            el.case_type_code === caseType &&
            el.panel_code === category &&
            (el.test_name.toLowerCase().includes(this.searchString.toLowerCase()) ||
              el.panel_title
                .toLowerCase()
                .includes(this.searchString.toLowerCase()))
        );
      } else {
        data = this.getNewLabGroupPanelTests.filter(
          (el) =>
            el.case_type_code === caseType && el.panel_code === category
        );
      }
      return this.sortByKey(data, "test_name");
    },
    getCategoriesWiseTestsData(caseType, categories, include = true) {
      let data = [];
      if (this.searchString) {
        data = this.getNewLabGroupPanelTests.filter(
          (el) =>
            el.case_type_code === caseType &&
            ((include && categories.indexOf(el.panel_code) != -1) ||
              (!include && categories.indexOf(el.panel_code) == -1)) &&
            (el.test_name.toLowerCase().includes(this.searchString.toLowerCase()) ||
              el.panel_title
                .toLowerCase()
                .includes(this.searchString.toLowerCase()))
        );
      } else {
        data = this.getNewLabGroupPanelTests.filter(
          (el) =>
            el.case_type_code === caseType &&
            ((include && categories.indexOf(el.panel_code) != -1) ||
              (!include && categories.indexOf(el.panel_code) == -1))
        );
      }

      return this.sortByKey(data, "test_name");
    },
    convertSelectedTestsInfoToPanels() {
      const grouped = {};
      this.panelsTestsData.selectedTestsInfo.forEach(item => {
        const panelId = `${item.case_type_code}||${item.panel_code}||${item.panel_id}`
        if (!grouped[panelId]) {
          grouped[panelId] = [];
        }
        grouped[panelId].push(item._id);
      });

      this.panelsTestsData.selectedCategories = Object.entries(grouped).map(
        ([panel_id, test_ids]) => {
          return {
            test_ids,
            case_type_code: panel_id.split("||")[0],
            panel_code: panel_id.split("||")[1],
            panel_id: panel_id.split("||")[2],
          }
        })
      this.selectedCategoriesWithTests = this.panelsTestsData.selectedTestsInfo.map((e) => e.label_value)
    },
    checkAll(check, caseType, panelId) {
      let data = [...this.getNewLabGroupPanelTests.filter(
        (el) =>
          el.case_type_code == caseType &&
          el.panel_id == panelId
      )];
      this.updateTestBasedOnEvent(check, data)
    },
    selectSingleTest(check, panelId, testId) {
      let data = [...this.getNewLabGroupPanelTests.filter(
        (el) =>
          el._id == testId &&
          el.panel_id == panelId
      )];
      this.updateTestBasedOnEvent(check, data)
    },
    updateTestBasedOnEvent(check, data) {
      if (check) {
        data.map((item) => {
          let testIndex = this.panelsTestsData.selectedTestsInfo.findIndex((e) => {
            return e._id == item._id && e.panel_id == item.panel_id
          })
          if (testIndex == -1) {
            this.panelsTestsData.selectedTestsInfo.push({ ...item })
          }
        });
      } else {
        check = false;
        data.forEach((item) => {
          let testIndex = this.panelsTestsData.selectedTestsInfo.findIndex((e) => {
            return e._id == item._id && e.panel_id == item.panel_id
          })

          if (testIndex != -1) {
            this.panelsTestsData.selectedTestsInfo.splice(
              testIndex,
              1
            );
          }
        });
      }
      this.convertSelectedTestsInfoToPanels()
    },
    isCheckAll(caseType, category) {
      let selectedCategory = this.panelsTestsData.selectedCategories.find(
        (selectedCategory) => selectedCategory.panel_id == category
      );

      if (selectedCategory) {
        let categoryTestInfo = this.getCategoryIdWiseTestsData(
          caseType,
          selectedCategory.panel_id
        );
        if (categoryTestInfo.length == selectedCategory.test_ids.length) {
          return true;
        }
        return false;
      }
      return false;
    },
    getCategoryIdWiseTestsData(caseType, categoryId) {
      let data = [];
      if (this.searchString) {
        data = this.getNewLabGroupPanelTests.filter(
          (el) =>
            el.case_type_code === caseType &&
            el.panel_id === categoryId &&
            (el.test_name
              .toLowerCase()
              .includes(this.searchString.toLowerCase()) ||
              el.panel_title
                .toLowerCase()
                .includes(this.searchString.toLowerCase()))
        );
      } else {
        data = this.getNewLabGroupPanelTests.filter(
          (el) => el.case_type_code === caseType && el.panel_id === categoryId
        );
      }



      return this.sortByKey(data, "test_name");
    },
    getAlreadySelectedData(selectedCategories) {
      let tests = [];
      selectedCategories.forEach(cat => {
        // get all tests for this panel
        let panelTests = this.getNewLabGroupPanelTests.filter(
          el => el.panel_id === cat.panel_id && el.case_type_code === cat.case_type_code
        );
        //  only keep the ones whose IDs are in cat.test_ids
        let selectedTests = panelTests.filter(test => cat.test_ids.includes(test._id));
        tests.push(...selectedTests);
      });
      return tests;
    },
    isMultiCheckAll(caseType, categories, include = true) {
      let categoryRelatedTests = [...this.getCategoriesWiseTestsData(
        caseType,
        categories,
        include
      )]

      return categoryRelatedTests.every((item) => {
        return this.panelsTestsData.selectedTestsInfo.findIndex((selectedTest) => {
          return selectedTest.panel_id == item.panel_id && selectedTest._id == item._id
        }) > -1
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.all-tests {
  display: flex;
  flex-wrap: wrap;

  .each-test {
    width: 33.33%;

    .each-check-box {
      .el-checkbox {
        display: flex;
        align-items: flex-start;
      }

      .el-checkbox__label {
        white-space: normal;
      }

      &:not(:last-child) {
        margin-bottom: 10px !important;
      }
    }
  }
}
</style>
<style lang="scss">
#toxicology-add-test-block {
  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  .el-tabs__nav-scroll {
    margin: 0 20px;
    overflow: auto;
  }

  .el-tabs__item {
    padding: 0 9px !important;
  }

  .el-tabs__nav-prev,
  .el-tabs__nav-next {
    display: none;
    font-size: 20px;
    background: #27347f;
    color: #ffffff;
    font-weight: 600;
    height: 100%;
  }
}

#pane-screening {
  .el-collapse-item__content {
    max-height: 350px;
  }
}
</style>
